import { FC, JSX, useContext } from "react";
import { QESButton } from "@app/shared/qes-standards/Button";
import { WizardNavigationBar } from "@app/shared/qes-standards/WizardNavigationBar";
import { FlyoutContext } from "@app/shared/Flyouts/FlyoutContext";

interface FlyoutFooterProps {
    cancelButtonText?: string;
    submitButton: JSX.Element;
    onClose?: () => void;
}

const FlyoutFooter: FC<FlyoutFooterProps> = (props: FlyoutFooterProps) => {
    const flyoutContext = useContext(FlyoutContext);

    const handleClose = () => {
      if (!!props.onClose){
        props.onClose();
      }
      flyoutContext.handleCloseFlyout();
    }

    return (
        <WizardNavigationBar
            leftSide={
                <QESButton
                    qesType="secondary-danger"
                    qesTestId="side-panel__cancel-button"
                    onClick={handleClose}
                >
                    {props.cancelButtonText || "Cancel"}
                </QESButton>
            }
            rightSide={props.submitButton}
            isInAFlyout={true}
        />
    )
}

export default FlyoutFooter;